import React from 'react';

const AboutUs = () => {
  return (
    <div style={{ 
    padding: "40px", 
    maxWidth: "800px", 
    margin: "0 auto",
    fontFamily: "Arial, sans-serif",
    fontSize: "20px" // Base font size increased
    }}>
    
    <section style={{ marginBottom: "30px" }}>
      <h2 style={{ fontSize: "28px", textAlign: "center" }}>Our Mission: Optimizing Capital Allocation with AI</h2>
    </section>

    <section style={{ marginBottom: "30px" }}>
      <h3 style={{ fontSize: "24px", textAlign: "center" }}>Who We Are</h3>
      <p style={{ textAlign: "left" }}>
      We are a financial technology startup dedicated to revolutionizing capital allocation for firms and high-net-worth individuals.
      By leveraging advanced AI-driven investment models, we help identify market and growth opportunities and manage risk with precision.
      </p>
    </section>

   
    </div>
  );
};

export default AboutUs;